module.exports = __webpack_public_path__ + "img/wb_ic_group.e8a794e5.svg";